export default __webpack_public_path__ + "static/media/icon-quizz.29608595.svg";